enum RecipientFieldEnum {
    /* Mail */
    To = 0,
    Cc = 1,
    Bcc = 2,
    /* Calendar */
    RequiredAttendees = 0,
    OptionalAttendees = 1,
    Resources = 2,
}

export default RecipientFieldEnum;
